import ArrowUpRightIcon from "@uui/ArrowUpRight";
import LockIcon from "@uui/Lock03";
import { useLocation, useNavigate } from "react-router-dom";

import { Typography } from "@mui/material";

import { withQueryParams } from "@app/common/utils";

import Button from "@rui/Button";
import { Row } from "@rui/Stack";

import { Blur, ContentContainer } from "./styles";

export interface UpsellOverlayProps {
  onClick?: () => void;
  children: React.ReactNode;
}

const UpsellOverlay = ({ children, onClick }: UpsellOverlayProps) => (
  <>
    <Blur onClick={onClick}>{children}</Blur>
    <ContentContainer onClick={onClick}>
      <Row variant="center" spacing={2} sx={{ color: "shades.neutral.500" }}>
        <Row spacing={1} variant="left">
          <LockIcon sx={{ fontSize: "16px", color: "shades.neutral.300" }} />
          <Typography variant="bodySecondaryMed" whiteSpace="nowrap">
            Report limit reached
          </Typography>
        </Row>

        <Button endIcon={<ArrowUpRightIcon />} sx={{ height: "36px" }}>
          Upgrade
        </Button>
      </Row>
    </ContentContainer>
  </>
);

const ConnectedUpsellOverlay = (props: UpsellOverlayProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOpenModal = () => {
    navigate(
      withQueryParams(location.pathname, { popup: "upgrade" }, location.search)
    );
  };

  return <UpsellOverlay onClick={handleOpenModal} {...props} />;
};

export { UpsellOverlay };
export default ConnectedUpsellOverlay;
